import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Tabs View"})
export default class TabsViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Large"})
	public large?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Vertical"})
	public vertical?: boolean;

	@Input({type: InputType.COLOR, title: "Color"})
	public color: string;

	@Input({type: InputType.PADDING, title: "Content Padding"})
	public contentPadding: string;

}



// WEBPACK FOOTER //
// ./src/common/views/tab/TabsViewConfig.ts